export const AccordiumData = [
  {
    question: "How do i place an order ?",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
  {
    question: "What are your shipping policies ?",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
  {
    question: "Can i change my address later ?",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
  {
    question: "Are there warranty on your products ?",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
  {
    question: "What is the estimated time of arrival ?",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
  {
    question: "Do you offer any discount ?",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
  {
    question: "What is your refund policy",
    answer:
      "You can place an order by simply registering on the website and searching for the product you want",
  },
];
